import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  dashboardDetails: null,
  dashboardProjectCount: null,
  dashboardFormStatusCount: null,
  dashboardWeldTotalBySystem: null || [],
  dashboardWeldProject: {
    result: [],
  },
  dasboardErrorWeldLog: null,
  error: null,
  dashboardRejectionBreakCount: null || [],
  dashboardWeldLogRejectionCount: null || [],
  dashboardWeldLogOtherTypeCount: null || [],
  dashboardWeldCountByWelder: null || [],
  dashboardMaterialToolLocation: null || [],
  dashboardMaterialToolClassification: null || [],
  dashboardMaterialTool: null || [],
  dashboardOperatorSummary: null || [],
  dashboardWelderSummary: null || [],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchDashboardSuccess(state, action) {
      state.isLoading = false;
      state.dashboardDetails = action.payload;
      state.error = null;
    },
    fetchDashboardFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchProjectDashboardStaticsStart(state) {
      state.error = null;
    },
    fetchProjectDashboardStaticsSuccess(state, action) {
      state.isLoading = false;
      state.dashboardProjectCount = action.payload;
      state.error = null;
    },
    fetchProjectDashboardStaticsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchProjectDashboardWeldStaticsStart(state) {
      state.error = null;
    },
    fetchProjectDashboardWeldStaticsSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWeldProject = action.payload;
      state.weldProjectData = {
        result: action.payload.result,
      };
      state.error = null;
    },
    fetchProjectDashboardWeldStaticsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchProjectDashboardFormStatusStart(state) {
      state.error = null;
    },
    fetchProjectDashboardFormStatusSuccess(state, action) {
      state.isLoading = false;
      state.dashboardFormStatusCount = action.payload;
      state.error = null;
    },
    fetchProjectDashboardFormStatusFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Dashboard Rejection Breakdown Count ..........................
    fetchDashboardRejectionBreakStart(state) {
      state.error = null;
    },
    fetchDashboardRejectionBreakSuccess(state, action) {
      state.isLoading = false;
      state.dashboardRejectionBreakCount = action.payload;
      state.error = null;
    },
    fetchDashboardRejectionBreakFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Dashboard Weld log Rejection Count ..........................
    fetchDashboardWeldLogRejectionBreakStart(state) {
      state.error = null;
    },
    fetchDashboardWeldLogRejectionBreakSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWeldLogRejectionCount = action.payload;
      state.error = null;
    },
    fetchDashboardWeldLogRejectionBreakFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Dashboard Weld log Other Inspection Count ..........................
    fetchDashboardWeldLogOtherStart(state) {
      state.error = null;
    },
    fetchDashboardWeldLogOtherSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWeldLogOtherTypeCount = action.payload;
      state.error = null;
    },
    fetchDashboardWeldLogOtherFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Weld Count by Welder ..........................
    fetchDashboardWeldCountBWelderStart(state) {
      state.error = null;
    },
    fetchDashboardWeldCountBWelderSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWeldCountByWelder = action.payload;
      state.error = null;
    },
    fetchDashboardWeldCountBWelderFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ...................... Weld total by system ...........................

    fetchWeldTotalBySystemStart(state) {
      state.error = null;
    },
    fetchWeldTotalBySystemSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWeldTotalBySystem = action.payload;
      state.error = null;
    },
    fetchWeldTotalBySystemFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Material Tool classification ..........................

    fetchMaterialToolClassificationStart(state) {
      state.error = null;
    },
    fetchMaterialToolClassificationSuccess(state, action) {
      state.isLoading = false;
      state.dashboardMaterialToolClassification = action.payload;
      state.error = null;
    },
    fetchMaterialToolClassificationFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Material Tool location ..........................

    fetchMaterialToolLocationStart(state) {
      state.error = null;
    },
    fetchMaterialToolLocationSuccess(state, action) {
      state.isLoading = false;
      state.dashboardMaterialToolLocation = action.payload;
      state.error = null;
    },
    fetchMaterialToolLocationFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Material Tool Statics ..........................

    fetchMaterialToolStart(state) {
      state.error = null;
    },
    fetchMaterialToolSuccess(state, action) {
      state.isLoading = false;
      state.dashboardMaterialTool = action.payload;
      state.error = null;
    },
    fetchMaterialToolFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Operator Summary Statics ..........................

    fetchOperatorSummaryStart(state) {
      state.error = null;
    },
    fetchOperatorSummarySuccess(state, action) {
      state.isLoading = false;
      state.dashboardOperatorSummary = action.payload;
      state.error = null;
    },
    fetchOperatorSummaryFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // .................... Welder Summary Statics ..........................

    fetchOperatorWelderStart(state) {
      state.error = null;
    },
    fetchOperatorWelderSuccess(state, action) {
      state.isLoading = false;
      state.dashboardWelderSummary = action.payload;
      state.error = null;
    },
    fetchOperatorWelderFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchErrorWeldLogStart(state) {
      state.error = null;
    },
    fetchErrorWeldLogSuccess(state, action) {
      state.isLoading = false;
      state.dasboardErrorWeldLog = action.payload;
      state.error = null;
    },
    fetchErrorWeldLogFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  fetchProjectDashboardStaticsStart,
  fetchProjectDashboardStaticsSuccess,
  fetchProjectDashboardStaticsFailure,
  fetchProjectDashboardWeldStaticsStart,
  fetchProjectDashboardWeldStaticsSuccess,
  fetchProjectDashboardWeldStaticsFailure,
  fetchProjectDashboardFormStatusStart,
  fetchProjectDashboardFormStatusSuccess,
  fetchProjectDashboardFormStatusFailure,
  fetchErrorWeldLogStart,
  fetchErrorWeldLogSuccess,
  fetchErrorWeldLogFailure,
  fetchDashboardRejectionBreakStart,
  fetchDashboardRejectionBreakSuccess,
  fetchDashboardRejectionBreakFailure,
  fetchDashboardWeldLogRejectionBreakStart,
  fetchDashboardWeldLogRejectionBreakSuccess,
  fetchDashboardWeldLogRejectionBreakFailure,

  fetchDashboardWeldCountBWelderStart,
  fetchDashboardWeldCountBWelderSuccess,
  fetchDashboardWeldCountBWelderFailure,

  fetchWeldTotalBySystemStart,
  fetchWeldTotalBySystemSuccess,
  fetchWeldTotalBySystemFailure,

  fetchMaterialToolClassificationStart,
  fetchMaterialToolClassificationSuccess,
  fetchMaterialToolClassificationFailure,
  fetchMaterialToolLocationStart,
  fetchMaterialToolLocationFailure,
  fetchMaterialToolLocationSuccess,
  fetchMaterialToolStart,
  fetchMaterialToolSuccess,
  fetchMaterialToolFailure,
  fetchOperatorSummaryStart,
  fetchOperatorSummarySuccess,
  fetchOperatorSummaryFailure,
  fetchDashboardWeldLogOtherStart,
  fetchDashboardWeldLogOtherSuccess,
  fetchDashboardWeldLogOtherFailure,
  fetchOperatorWelderStart,
  fetchOperatorWelderSuccess,
  fetchOperatorWelderFailure,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
